export default "__VITE_ASSET__BvGPP0l$__"